import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, arrearsTransactionTableAdapter, ArrearsTransactionTableInstance } from '../reducers/arrears-transaction-table.reducer'

import { ITable, IRow } from '@common/models/table';
import { ArrearsTransactionFilterFieldProvider } from '../filter/arrears-transactions-filter-field-provider';
import { getFilter as getArrearsFilter } from './arrears.selectors';
import { RuleSet, Rule } from 'ngx-angular-query-builder';

import * as lodash from 'lodash';
import { StandardFilterStrategy } from '@common/filter/standard-filter-strategy';


export const selectArrearsTableState = createFeatureSelector<State>('debtAnalysisTransaction');

export const {
  selectIds,
  selectEntities,
  selectTotal,
} = arrearsTransactionTableAdapter.getSelectors(selectArrearsTableState);


export const selectEntityByWidgetId = (widgetId: string) => createSelector(selectEntities, (entities) => entities[widgetId.toString()]);

export const getArrearsTransactions =
  (arrearsTransactionTableInstance: ArrearsTransactionTableInstance) => arrearsTransactionTableInstance
    .arrearsTransactionTable;

export function getArrearsTransactionsWithDataKey(widgetId: string, widgetConfigId: number) {
  return createSelector(
    [selectEntityByWidgetId(widgetId), getArrearsFilter(widgetId, widgetConfigId)],
    (arrearsTransactionTableInstance: ArrearsTransactionTableInstance, filter: RuleSet) => {
      const table = lodash.cloneDeep(getArrearsTransactions(arrearsTransactionTableInstance));
      if (table != undefined) {
        const filterFieldProvider = getArrearsFilterFieldProvider(table);
        const filterStrategy = new StandardFilterStrategy<IRow>(filterFieldProvider);
        const processedFilter = createSystemRuleSetFromRuleSet(filter);

        table.Rows = filterStrategy.applyFilter(table.Rows, processedFilter);

        let count = 1;
        for (const tenancy of table.Rows) {

          tenancy.DataKey = String(count++);
        }
        return table;
      }
      return table;
    }
  );
}

export const hasArrearsTransactionData = (widgetId: string) => {
  return createSelector(
    [selectEntityByWidgetId(widgetId)],
    isValidTable
  );
}

export const isValidTable = (arrearsTransactionTableInstance: ArrearsTransactionTableInstance) => {
  return arrearsTransactionTableInstance != undefined &&
    arrearsTransactionTableInstance.arrearsTransactionTable != undefined;
}

export function getDrillDownModel(widgetId: string) {
  return createSelector(
    [selectEntityByWidgetId(widgetId)],
    (arrearsTransactionTableInstance: ArrearsTransactionTableInstance) => {
      return arrearsTransactionTableInstance.drillDownModel;
    }
  );
}

export function getArrearsFilterFieldProvider(table: ITable): ArrearsTransactionFilterFieldProvider {

  return new ArrearsTransactionFilterFieldProvider(table);
}

function isRuleSet(pet: RuleSet | Rule): pet is RuleSet {
  return (<RuleSet>pet).condition !== undefined;
}

const processRuleSet = (ruleSet: RuleSet) => {
  ruleSet.rules.forEach((ruleOrRuleSet) => {
    if (isRuleSet(ruleOrRuleSet)) {
      processRuleSet(ruleOrRuleSet);
    } else {
      processRule(ruleOrRuleSet);
    }
  });
}

const processRule = (rule: Rule) => {
  rule.field = 'System' + rule.field;
}

export const createSystemRuleSetFromRuleSet = (ruleSet: RuleSet) => {
  const copyOfFilter: RuleSet = lodash.cloneDeep(ruleSet);
  processRuleSet(copyOfFilter);
  return copyOfFilter;
}

